import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const planes = [{
  name: "Free",
  price: "0",
  desc: "Para comenzar a cumplir",
  features: ["1 usuario · 10 clientes", "Screening PEP/OFAC", "Reportes PDF"],
  cta: "Empieza gratis",
  highlight: false
}, {
  name: "Basic",
  price: "19",
  desc: "Para equipos pequeños",
  features: ["Hasta 10 usuarios · 50 clientes", "15 onboardings/mes", "Soporte por email"],
  cta: "Elegir Basic",
  highlight: false
}, {
  name: "Standard",
  price: "39",
  desc: "Cumple con la ley",
  features: ["Min. 3 usuarios · 250 clientes", "Reportes XML SAT/UIF", "Dashboard de cumplimiento"],
  cta: "Elegir Standard",
  highlight: true
}, {
  name: "Pro",
  price: "59",
  desc: "Cumple eficientemente",
  features: ["Min. 5 usuarios · 500 clientes", "OCR automático", "Audit log y API"],
  cta: "Elegir Pro",
  highlight: false
}];
export default function PreciosPreview() {
  return <section data-section-id="REEMPLAZAR" id="precios-preview" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Planes que <span className="text-primary font-mono">crecen contigo</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Desde joyerías de una sola sucursal hasta notarías, desarrolladoras y corporativos con múltiples oficinas. Notalia se ajusta a cualquier sujeto obligado de la LFPIORPI — sin importar tu giro. Todos los planes incluyen KYC, screening PEP/OFAC y tu logo en los expedientes.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {planes.map((plan, i) => <div key={plan.name} data-index={i} className={`relative p-6 rounded-lg border-2 transition-all duration-200 flex flex-col ${plan.highlight ? "border-primary bg-primary/5" : "border-border bg-card hover:border-primary/30"}`}>
              {plan.highlight && <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-lg bg-primary text-primary-foreground text-xs font-mono uppercase tracking-wider">
                  Recomendado
                </span>}
              <h3 className="font-default text-xl font-bold text-white">{plan.name}</h3>
              <p className="text-sm text-slate-400 font-default mt-1">{plan.desc}</p>
              <div className="mt-6 flex items-baseline">
                <span className="font-mono text-4xl font-extrabold text-white">${plan.price}</span>
                <span className="ml-1 text-sm text-slate-400 font-mono">USD/mes</span>
              </div>
              <ul className="mt-6 space-y-3 flex-1">
                {plan.features.map((f, j) => <li key={j} className="flex items-start gap-2">
                    <Check className="size-4 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-sm text-slate-300 font-default">{f}</span>
                  </li>)}
              </ul>
              <Link to="https://panel.notalia.app/" className="mt-6">
                <Button className={`w-full ${plan.highlight ? "bg-primary hover:bg-primary/90 text-primary-foreground" : "bg-card hover:bg-card/80 border border-border text-white"}`}>
                  {plan.cta}
                </Button>
              </Link>
            </div>)}
        </div>
        <div className="mt-10 text-center">
          <p className="text-sm text-muted-foreground font-default mb-4">
            ¿Necesitas más usuarios, almacenamiento o integración a medida?
          </p>
          <Link to="#">
            <Button variant="ghost" className="font-mono uppercase tracking-widest text-primary hover:text-primary hover:bg-primary/10">
              Ver Enterprise y comparativa completa
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}